import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useMessages } from '../slices/ui'
import Message from './Message'

const MessagesManager = (props) => {
  const {childrens} = props
  const messages = useMessages();
  if (!messages && !childrens) return null
  return (
    <ul className="pwa__messages fade-in">
      { childrens  }
      { messages.map(x => <Message {...x} key={x.id}/>) }
    </ul>
  )
}

export default MessagesManager;
